import * as React from "react";
import { forwardRef } from "react";
const SvgHome4Fill = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M13.228 2.688a2 2 0 0 0-2.456 0l-8.384 6.52C1.636 9.795 2.05 11 3.003 11H4v8a2 2 0 0 0 2 2h5v-7a1 1 0 0 1 2 0v7h5a2 2 0 0 0 2-2v-8h.997c.952 0 1.368-1.205.615-1.791z" }));
const ForwardRef = forwardRef(SvgHome4Fill);
export default ForwardRef;
